module.exports = __webpack_public_path__ + "14c05304a662c3bcd74be7f6efdcb8e3.pdf";